<template>
  <div>
    <div
      :class="[header ? 'h5-headline black--text': 'h9-label' ,'mb-3']">
      {{ $t('Tenders.CalculationFormula') }}
    </div>
    <StandartReducedPrice
      v-if="!item && card.useStandardReducedPrice"
      :variables.sync="variables_in_standart"/>
    <AddMathFormula
      v-else-if="growthBook.use_mathjs"
      :error.sync="formula_error_math"
      :formula.sync="new_formula"
      :max_length="item ? 4000 : 254"
      :variables="ready_creiteria.map(readyCreiteriaItem=> ({key: readyCreiteriaItem.variable, value: 1}))"/>
    <AddFormula
      v-else
      ref="add_formula"
      :card="card"
      :error.sync="formula_error"
      :formula.sync="new_formula"
      :header="header"
      :max_length="item ? 4000 : 254"
      :subheader="subheader"
      :variables="ready_creiteria"/>
    <sIcon
      v-if="loading"
      color="var(--v-secondary__green_not_active-base)"
      size="30"
      spin
      type="loading"/>
    <div
      class=" mt-6 variables">
      <div class="h4-headline variables_title">
        {{ $t('Tenders.AddAvailableVariablesForFormula') }}
      </div>
      <sDivider
        class="my-3"
        color="var(--v-main__green-base)"/>
      <div class="text-start h6-text variables_subtitle">
        {{ vars_hint }}
      </div>
      <div
        v-if="ready_creiteria && ready_creiteria.length"
        class="main__light_green variables_list pt-7"
        data-qa="variables-list">
        <div
          class="variables_items"
          data-qa="criterion-variable">
          <div
            class="variables_item">
            {{ $t('Tenders.Variable') }}
          </div>
          <div
            class="variables_item">
            {{ $t('Tenders.Criterion') }}
          </div>
          <div class="variables_item"/>
        </div>
        <sDivider
          color="var(--color-main-green)"
          :size="1"/>
        <template v-for="(readyCriteria, n) in ready_creiteria">
          <div
            :key="n"
            class="variables_list-items"
            data-qa="criterion-variable">
            <div
              class="variables_list-item"
              data-qa="variable">
              {{ readyCriteria.variable || '-' }}
            </div>
            <div
              :key=" readyCriteria.variable + readyCriteria.criterionCode + readyCriteria.title"
              class="variables_list-item">
              <div
                class="h6-text black--text text-left"
                data-qa="variable-title">
                {{ readyCriteria.title }}
              </div>
              <div
                class="variables_list-item-subtext"
                data-qa="variable-value">
                {{ $t(`Tenders.${readyCriteria.type}`) }}
                <ShowFormula
                  v-if="readyCriteria.type === 'CALCULATED' && readyCriteria.value"
                  :formula-string="readyCriteria.value"
                  :use-space="true"/>
                <template v-else>
                  {{ readyCriteria.value ? ': ' + readyCriteria.value : '' }}
                </template>
              </div>
              <RadioGroup
                v-if="checkDisabledVar( readyCriteria.variable, item)"
                class-name="mt-0 py-0 pb-1 px-2"
                data-qa="add-given-price"
                :header="`${$t('Tenders.TenderWithGivenPrice')}?`"
                header_class="h8-text mt-2"
                label_class="h8-text"
                :model.sync="card.useReducedPrice"
                row/>
            </div>
            <div
              class="variables_list-item">
              <sButton
                data-qa="add-variable"
                :disabled=" readyCriteria.disabled"
                :icon="checkSelected(readyCriteria) ? 'cross' : 'plus'"
                :icon-size="checkSelected(readyCriteria) ? '10px' : '16px'"
                small
                type="green"
                @click="select(readyCriteria)"/>
            </div>
          </div>
          <sDivider
            :key="n + 'div'"
            class="mt-2"/>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import ShowFormula from 'components/common/ShowFormula.vue'
import RadioGroup from 'components/common/inputs/RadioGroup.vue'
import AddFormula from 'components/tenders/critetia/AddFormula.vue'
import AddMathFormula from 'components/tenders/critetia/AddMathFormula.vue'
import StandartReducedPrice from 'components/tenders/critetia/StandartReducedPrice.vue'

import { mapGetters } from 'vuex'
import { criteriasMixin, functionRandom } from 'mixins'

export default {
  name: 'changeFormula',
  mixins: [criteriasMixin, functionRandom],
  data() {
    return {
      dialog: false,
      loading: false,
      timeout: 0,
      variable: ''
    }
  },
  props: {
    header: Boolean,
    subheader: Boolean,
    formula: String,
    card: Object,
    criteria: {
      type: Array,
      default: () => []
    },
    variables: Array,
    disabled: Boolean,
    item: Object,
    error: Boolean,
    reducedPriceAvailable: Boolean,
    error_math: Object,
  },
  computed: {
    ...mapGetters({
      tender: 'getNewTender',
    }),
    vars_hint() {
      if ( !this.item && this.card.useStandardReducedPrice ) {
        return !this.ready_creiteria?.length ? this.$t('Tenders.AddCriterionToUseStandartPrice') : this.$t('Tenders.CriterionToUseInStandartPrice')
      }
      return this.$t('Tenders.CriterionToUseInOwnPrice')
    },
    ready_creiteria() {
      return this.getVariablesForFormula(this.criteria, this.item)
    },
    new_formula: {
      get() {
        return this.formula || ''
      },
      set(val) {
        this.$emit('update:formula', val || '')
      }
    },
    formula_error_math: {
      get() {
        return this.error
      },
      set(val) {
        if (this.$refs.add_formula) {
          this.$refs.add_formula.new_formula = this.new_formula
          this.$nextTick(() => {
            this.$refs.add_formula.updFormula()
          })
        } else {
          this.$emit('update:error', !!val.key)
        }
        this.$emit('update:error_math', val)
      }
    },
    formula_error: {
      get() {
        return this.error
      },
      set(val) {
        this.$emit('update:error', val)
      }
    },
    variables_in_standart() {
      return this.card.criterias.map(el => el.useInRedFormula && el.formulaCode).filter(el => el) || []
    },
  },
  methods: {
    select(item) {

      if ( !item.variable ) {
        let check_var = () => {
          if ( !item.variable || this.$_.countBy(this.card?.criterias, 'formulaCode' )[item.variable] > 1 ) {
            let variable = this.variable
            if ( variable ) {
              variable = this.variable.codePointAt(this.variable.length - 1) + 1
              if ( variable > 90 ) {
                let prev = this.variable.codePointAt(this.variable.length - 2) + 1
                if ( prev < 90) {
                  variable = this.variable.slice(0, -2) + String.fromCodePoint(prev)
                } else if ( prev ) {
                  variable = this.variable.slice(0, -2) + 'AA'
                } else if ( !prev ) {
                  variable = 'A'
                }
                variable = variable + 'A'
              } else {
                variable = this.variable.slice(0, -1) + String.fromCodePoint(variable)
              }
            } else {
              variable = 'A'
            }

            item.variable = variable
            this.variable = variable

            item.item.formulaCode = item.variable
            check_var()
          }
        }
        check_var()
      }
      if ( !this.item && this.card.useStandardReducedPrice ) {
        if ( item.item.useInRedFormula ) {
          item.item.useInRedFormula = false
        } else {
          item.item.useInRedFormula = true
        }
        this.saveCardToLocalStorage(this.tender, this.card)
        return
      }
      if ( !this.new_formula?.length || this.new_formula?.trim().slice(-1).match(/[-+/*(]/g) ) {
        this.new_formula += item.variable
      } else {
        this.new_formula += ' + ' + item.variable
      }
      this.saveCardToLocalStorage(this.tender, this.card)
      this.$nextTick(this.$refs.add_formula?.updFormula)
    },
    checkSelected(criteria) {
      return !this.item && this.card.useStandardReducedPrice && criteria.item && criteria.item.useInRedFormula
    }
  },
  components: {
    RadioGroup,
    AddFormula,
    ShowFormula,
    AddMathFormula,
    StandartReducedPrice
  }
}
</script>
<style lang="scss" scoped>
.variables {
  color: var(--text-color);
  &_title {
    word-break: break-word;
    text-align: left;
  }
  &_list-items,
  &_items {
    display: grid;
    grid-template-columns: 100px auto 55px;
  }
  &_item {
    word-wrap: break-word;
    padding: 12px;
    text-align: left;
    text-transform: uppercase;
    font-size: 11px;
  }
  &_list {
    &-item {
      padding: 12px;
      text-align: left;
      font-size: 11px;
      word-wrap: break-word;
      &:first-child {
        font-size: 16px;
        line-height: 20px;
      }
      &-subtext {
        color: rgba(var(--black-color-rgba), .6);
        font-size: 14px;
        line-height: 18px;
        text-align: left;
      }
    }
  }
}
</style>
